import { AssetTypeEnum, type Asset } from './asset';
import type { SearchParameters } from './searchParameters';
import {
  AssetFamilySearchFilterEnum,
  AssetTypeSearchFilterEnum,
} from './searchParameters';

// This file holds cross-aggregate boolean specifications: rules that span more
// than one domain model and answer a yes/no question. Rules that depend on a
// single model live on that model (via its factory); cross-aggregate rules that
// derive domain objects rather than a boolean live in a `*.service` file.

// An editorial-use-only image is "exclusive" unless the search is itself scoped
// to editorial images — an editorial + image search that is not a
// search-by-image query. A search-by-image query is not treated as
// editorial-scoped, so the image stays exclusive there.
export const isAssetExclusive = (
  asset: Asset,
  searchParameters: SearchParameters
): boolean =>
  asset.isEditorialUseOnly &&
  asset.assetType === AssetTypeEnum.IMAGE &&
  !(
    searchParameters.family === AssetFamilySearchFilterEnum.EDITORIAL &&
    searchParameters.assettype === AssetTypeSearchFilterEnum.IMAGE &&
    !searchParameters.searchByImage
  );
